import { Nullable } from "../../../../common/types/nullable";

// TODO: Change the modals to use react-hook-form
export const isValidAmount = (amount: Nullable<string>): boolean => {
  if (!amount) {
    return false;
  }

  const parsedAmount = parseFloat(amount.replace(",", "."));

  return !isNaN(parsedAmount);
};

export const isValidComment = (comment: Nullable<string>): boolean => {
  return !(comment && comment.length > 128);
};
